import { IPromocodeItem } from "./types/bonusesActions";

export const CHECK_BONUS_PROMOCODE_START = 'CHECK_BONUS_PROMOCODE_START' as const;
export const CHECK_BONUS_PROMOCODE_SUCCESS = 'CHECK_BONUS_PROMOCODE_SUCCESS' as const;
export const CHECK_BONUS_PROMOCODE_FAILURE = 'CHECK_BONUS_PROMOCODE_FAILURE' as const;

export const CLEAR_BONUS_PROMOCODE = 'CLEAR_BONUS_PROMOCODE' as const;
export const SET_BONUS_PROMOCODE = 'SET_BONUS_PROMOCODE' as const;

export const SET_ACTIVE_PROMOCODES_START = 'SET_ACTIVE_PROMOCODES_START' as const;
export const SET_ACTIVE_PROMOCODES_SUCCESS = 'SET_ACTIVE_PROMOCODES_SUCCESS' as const;
export const SET_ACTIVE_PROMOCODES_FAILURE = 'SET_ACTIVE_PROMOCODES_FAILURE' as const;

export const SET_USED_PROMOCODES_START = 'SET_USED_PROMOCODES_START' as const;

export const SET_WELCOME_APPLY_BONUS = 'SET_WELCOME_APPLY_BONUS' as const;
export const SET_WELCOME_BANNER_OPENED = 'SET_WELCOME_BANNER_OPENED' as const;

export const CLEAR_BONUSES = 'CLEAR_BONUSES' as const;

export const BONUSES_SET_ACTIVE_START = 'BONUSES_SET_ACTIVE_START' as const;
export const BONUSES_SET_ACTIVE_SUCCESS = 'BONUSES_SET_ACTIVE_SUCCESS' as const;
export const BONUSES_SET_ACTIVE_FAILURE = 'BONUSES_SET_ACTIVE_FAILURE' as const;

export const BONUSES_SET_AVAILABLE = 'BONUSES_SET_AVAILABLE' as const;

export const GET_NEW_LIFE_ACCOUNTS_START = 'GET_NEW_LIFE_ACCOUNTS_START' as const;
export const GET_NEW_LIFE_ACCOUNTS_SUCCESS = 'GET_NEW_LIFE_ACCOUNTS_SUCCESS' as const;
export const GET_NEW_LIFE_ACCOUNTS_FAILURE = 'GET_NEW_LIFE_ACCOUNTS_FAILURE' as const;

export const SET_NEW_LIFE_RESPAWN_START = 'SET_NEW_LIFE_RESPAWN_START' as const;
export const SET_NEW_LIFE_RESPAWN_SUCCESS = 'SET_NEW_LIFE_RESPAWN_SUCCESS' as const;
export const SET_NEW_LIFE_RESPAWN_FAILURE = 'SET_NEW_LIFE_RESPAWN_FAILURE' as const;

export const SET_NEW_LIFE_RESPAWN_BANNER_OPENED = 'SET_NEW_LIFE_RESPAWN_BANNER_OPENED' as const;

export const PROCESS_INIT_PROMOCODE_START = 'PROCESS_INIT_PROMOCODE_START';

export const BONUS_NAMES = {
    WELCOME: 'welcome',
    GIFT50: 'gift_50',
    NEW_LIFE: 'new_life',
    DEPOSIT: 'deposit',
}

export const BONUS_STATUSES = {
    ACTIVE: 'active',
    CANCELED: 'canceled',
    DECLINED: 'declined',
    NOT_APPLICABLE: 'not_applicable',
    PROCESSING: 'processing',
    WAITING: 'waiting',
    WAGERED: 'wagered',
    WITHDRAWN: 'withdrawn'
}

export const PROMOCODE_NAMES = {
    DEPOSIT: 'deposit',
    HELLOJETVIX: 'hellojetvix',
    YELLOWDAYS: 'yellowdays',
    WELCOME: 'welcome',
} as const;

export const PROMOCODE_TYPES = {
    DEPOSIT: 'deposit',
    NODEPOSIT: 'nodeposit',
} as const;

export const PROMOCODE_DESTINATIONS = {
    CREDIT: 'credit',
    DEPOSIT: 'deposit',
} as const;

export const PROMOCODE_DEFAULT_LIST: IPromocodeItem['promocode'][] = [
    PROMOCODE_NAMES.DEPOSIT,
    PROMOCODE_NAMES.WELCOME,
];
